import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { IResponse } from '../../app-interface';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 'app-add-faq',
  templateUrl: './add-faq.component.html'
})
export class AddFaqComponent implements OnInit {
  public showPass = false;
  public addFaq: FormGroup;
  public data;
  public addEvent = new EventEmitter();
  public reasonLabel = true;
  showCountryCode = false;
  constructor(public formBuilder: FormBuilder, public modalRef: BsModalRef, public toaster: ToastrService, public utilityService: UtilityService) {
    this.addFaq = this.formBuilder.group({
      question: ['', [Validators.required]],
      answer: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.addFaq.patchValue({
      question: this.data && this.data.question,
      answer: this.data && this.data.answer
    });
  }
  get question() { return this.addFaq.get('question'); }
  get answer() { return this.addFaq.get('answer'); }

  /**
   * API Call for submitting the user profile
  */
  submitFaq() {
    if (this.addFaq.valid) {
      const params = {
        'question': this.addFaq.value.question,
        'answer': this.addFaq.value.answer
      };
      this.utilityService.addFaq(params).subscribe((res: IResponse) => {
        if (res && !res.errors) {
          this.toaster.success(res.message);
          this.addEvent.emit({ res: 200 });
          this.modalRef.hide();
        }
      });
    } else {
      this.addFaq.markAllAsTouched();
    }
  }
}
